module.exports = __webpack_public_path__ + "img/80.cleaning.4e892c6e.svg";